import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {RoleGuard} from '@services/role.guard';
import {UserSettingsComponent} from './user-settings.component';

const route: Routes = [
  {path: 'settings', component: UserSettingsComponent, canActivate: [RoleGuard], data: {expectedRole: '2'}},
];

@NgModule({
  imports: [
    RouterModule.forChild(route)
  ],
  exports: [
    RouterModule
  ]
})

export class UserSettingsRoutingModule {
}




// WEBPACK FOOTER //
// ./src/app/modules/user-settings/user-settings-routing.module.ts